import React, { useEffect, useRef } from "react";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useDispatch } from "react-redux";
import { ScrollActions } from "../../store/Slices/ScrollSlice";

import Row from "../UI/Row/Row";
import Space from "../UI/Space/Space";

import classes from "./OurWork.module.css";

import logoHD from "../../images/logoHD.png";
import Person from "../../images/Person.png";
import Group from "../../images/Group.png";
import AnimatedCard from "../UI/AnimatedCard/AnimatedCard";

const OurWork = () => {
  const dispatch = useDispatch();
  const container = useRef(null);

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    let trigger = ScrollTrigger.create({
      trigger: container.current,
      start: "top bottom",
      end: "bottom bottom", 
      scrub: true,
      // markers: true,
      onUpdate: (self) => {
        // console.log("progress", self.progress);
        dispatch(ScrollActions.UpdateOurWork(self.progress));
      },
    });
    return()=>{
      trigger.kill();
    }

  // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.container} ref={container}>
      <Space height={"200px"} />
      <Row>
        <AnimatedCard className={classes.item}>
          <img src={logoHD} alt={"logoHD"} />
        </AnimatedCard>
        <AnimatedCard className={classes.item + " " + classes.card}>
          <h2>
            <span className={classes.yellow}> LWAH</span> is non-governmental
            not for profit organization founded in 1984, by Mrs. Randa Assi
            Berri and has special consultative status with the UN economic and
            social council since the year 2000.
          </h2>
        </AnimatedCard>
      </Row>
      <Space height={"200px"} />
      <Row>
        <AnimatedCard className={classes.item + " " + classes.card}>
          <h2>
            Its mission is to improve the quality of life for people with
            special needs and enhance their dignity, independence and
            productivity.
          </h2>
        </AnimatedCard>
        <AnimatedCard className={classes.item}>
          <img src={Person} alt={"Person"} />
        </AnimatedCard>
      </Row>
      <Space height={"200px"} />
      <Row>
        <AnimatedCard className={classes.long + " " + classes.card}>
          <h2 style={{ textAlign: "center" }}>
            <span className={classes.yellow}>LWAH</span> provides full
            rehabilitation services through its three centers in Beirut, Baalbek,
            and Sarafand. Its main center is the Nabih Berri Rehabilitation
            Compound (NBRC), built over an area of 23,000 m² in South Lebanon. It
            offers comprehensive medical and rehabilitation services through its
            different units, ranging from diagnosis and treatment to physical
            therapy, psychosocial, educational, occupational, vocational, and
            recreational rehabilitation.{" "}
            <span className={classes.yellow}>LWAH</span> also partners with
            Phoenicia University (PU), seeking consultation from PU faculty
            members, where necessary, in relation to rehabilitation services,
            events, campaigns, and other related activities.{" "}
            <span className={classes.yellow}>LWAH</span> serves more than 340
            patients per day and has over 39,000 registered patients.
          </h2>
        </AnimatedCard>
      </Row>
      {/* <Space height={"100px"} />
      <Row>
        <div className={classes.item}>
          <img src={Wheelchair} alt="Wheelchair" />
        </div>
      </Row> */}
      <Space height={"200px"} />

      <Row>
        <AnimatedCard className={classes.item}>
          <img src={Group} alt="Group" />
        </AnimatedCard>
        <AnimatedCard className={classes.item + " " + classes.card}>
          <h2>
            It has come far in the last few years, and with the commitment of
            its professional and dedicated staff,{" "}
            <span className={classes.yellow}>LWAH</span> is proud to have
            acquired ISO certification 9001:2008 after effectively implementing
            the set of requirements insuring quality management.
          </h2>
        </AnimatedCard>
      </Row>
      <Space height={"200px"} />
    </div>
  );
};
export default OurWork;
